import React from 'react';
import { NeoBadge, NeoButton, NeoTable, AvatarPreview } from '../../../../components/Common';
import { formatDateTime } from '../../../../utils/date';

const getActionBadgeProps = (action) => {
    switch (action) {
        case 'CREATE': return { color: 'success', icon: 'mdi-plus-circle' };
        case 'UPDATE': return { color: 'warning', icon: 'mdi-pencil' };
        case 'DELETE': return { color: 'danger', icon: 'mdi-delete' };
        default: return { color: 'secondary', icon: 'mdi-information' };
    }
};

/**
 * AuditList — Exibe a lista de logs de auditoria usando o NeoTable.
 * Migrado para o Neo Design System (Taça Outono) com NeoBadge e NeoButton.
 */
const AuditList = ({ logs, loading, hasMore, onLoadMore, onViewDetails }) => {

    const columns = [
        {
            key: 'createdAt',
            label: 'Data/Hora',
            width: "150px",
            render: (row) => (
                <div className="d-flex align-items-center font-size-12 fw-bold text-muted">
                    <i className="mdi mdi-clock-outline me-1 text-muted"></i>
                    {row.createdAt ? formatDateTime(row.createdAt) : '-'}
                </div>
            )
        },
        {
            key: 'userName',
            label: 'Usuário',
            width: "170px",
            render: (row) => (
                <div className="d-flex align-items-center gap-2">
                    <AvatarPreview
                        alt={row.userName}
                        size="xs"
                        fallbackType="icon"
                        style={{ border: "1.5px solid rgba(72, 39, 18, 0.15)" }}
                    />
                    <span className="fw-semibold text-dark font-size-13" style={{ fontFamily: "Outfit, sans-serif" }}>
                        {row.userName || '-'}
                    </span>
                </div>
            )
        },
        {
            key: 'module',
            label: 'Módulo',
            width: "130px",
            render: (row) => (
                <NeoBadge color="secondary">
                    {row.module || '-'}
                </NeoBadge>
            )
        },
        {
            key: 'action',
            label: 'Ação',
            width: "90px",
            render: (row) => {
                const props = getActionBadgeProps(row.action);
                return (
                    <NeoBadge color={props.color} icon={props.icon}>
                        {row.action}
                    </NeoBadge>
                );
            }
        },
        {
            key: 'description',
            label: 'Descrição',
            render: (row) => (
                <span className="text-muted font-size-12 text-wrap" style={{ lineHeight: "1.3" }}>
                    {row.description || '-'}
                </span>
            )
        },
        {
            key: 'details',
            label: 'Ações',
            width: "70px",
            align: 'center',
            render: (row) => (
                <NeoButton 
                    variant="soft-primary" 
                    size="sm"
                    square
                    icon="mdi-eye-outline"
                    disabled={!row.details}
                    onClick={() => onViewDetails(row)}
                    title="Ver Detalhes"
                />
            )
        }
    ];

    return (
        <React.Fragment>
            <div className="w-100">
                <NeoTable
                    data={logs}
                    columns={columns}
                    keyField="id"
                    defaultItemsPerPage={25}
                    isLoading={loading && logs.length === 0}
                    emptyMessage="Nenhum registro de auditoria encontrado"
                    emptySubMessage="Tente ajustar os filtros acima para encontrar registros."
                />

                {/* Botão Carregar Mais com loading animado outonal */}
                {hasMore && logs.length > 0 && (
                    <div className="text-center p-3 border-top mt-3" style={{ borderColor: "rgba(72, 39, 18, 0.08)" }}>
                        <NeoButton 
                            variant="outline-chocolate"
                            size="sm"
                            onClick={onLoadMore}
                            loading={loading}
                            loadingText="Buscando..."
                            icon="mdi-chevron-down"
                        >
                            Buscar Registros Antigos
                        </NeoButton>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

export default AuditList;
